import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { AuditionEnhancer } from '@/components/SelfTapeEnhancer';

const AuditionEnhancerPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { toast } = useToast();

  useEffect(() => {
    if (searchParams.get('subscription') === 'success') {
      toast({
        title: 'Welcome to Hey Joe Plus!',
        description: 'Your subscription is active. Upload a self-tape to get started.',
      });
      searchParams.delete('subscription');
      setSearchParams(searchParams, { replace: true });
    }
  }, []);

  return <AuditionEnhancer />;
};

export default AuditionEnhancerPage;
